import { createSlice } from "@reduxjs/toolkit";
import { areaDetailsAPI } from "../../api/chef";

const data = {
  isLoading: false,
  error: "",
  message: null,
  data: null,
}; 

const addAreaDetailsSlice = createSlice({
  name: "areaDetails",
  initialState: data,
  reducers: {
   addAreaDetailsSlice(state) {
      state.isLoading = true;
    },
   areaDetailsSliceSuccess(state, action) {
      state.isLoading = false;
      state.data = action.payload;
    },
    areaDetailsSliceFailure(state, action) {
      state.isLoading = false;
      state.data = action.payload;
    },
    areaDetailsSliceReset(state) {
      state.isLoading = false;
      state.data = null;
    },
  },
});

export const areaDetailsHandler = (data:any) => async (dispatch: any) => {
  try {
    dispatch(areaDetailsAction.addAreaDetailsSlice());
    const response: any = await areaDetailsAPI(data);
    
    dispatch(areaDetailsAction.areaDetailsSliceSuccess(response));
  } catch (e: any) {
    dispatch(areaDetailsAction.areaDetailsSliceFailure(e?.response?.data));
  }
};

export default addAreaDetailsSlice.reducer;
export const areaDetailsAction = addAreaDetailsSlice.actions;